import React from 'react'

const Logo = () => {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511 288" preserveAspectRatio="xMidYMid meet" className="logo-personal">
      <title>John Mantas</title>
      <g transform="translate(0,288) scale(0.1,-0.1)">
        <path d="M2392 2727 c-83 -84 -152 -157 -152 -162 0 -6 69 -79 153 -163 l152 -152 175 0 175 0 -810 -810 -810 -810 -485 0 -485 0 -153 -153 c-83 -84 -152 -157 -152 -162 0 -6 69 -79 153 -163 l152 -152 625 0 625 0 1110 1112 c611 612 1256 1260 1435 1441 l325 327 -940 0 -940 0 -153 -153z" />
        <path d="M3791 2014 l-861 -865 0 -225 0 -224 227 0 228 0 547 547 548 548 0 -745 0 -745 153 -153 c84 -83 157 -152 162 -152 6 0 79 69 163 153 l152 152 0 1288 0 1287 -229 0 -229 0 -861 -866z" />
      </g>
    </svg>
  )
}

export default Logo